import { classNames } from "primereact/utils";
import { Controller, useForm } from "react-hook-form";
import {
  Base64Encoder,
  BcryptEncoder,
  checkDpSuccess,
  getCompanyType,
  getFormErrorMessage,
} from "../../../utility/service/tool-service";
import { getCarbonPlanList, getCompanyPlaceList } from "../../../utility/service/carbon-service";
import { SystemLoading, checkLoading } from "../../../store/loadingStore";
import { useContext, useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import PrimeTableFooter from "../../../components/PrimeTableFooter";
import NoInfo from "../../../components/NoInfo";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getSubItemsByItemNo } from "../../../utility/service/api-service";

const ConsolidateList = ({ planYearList, setSelPlan, selPlan, defaultCompanySeq = "" }) => {
  const { t } = useTranslation();
  const [, loading] = useContext(SystemLoading);
  const [isLoading, setIsLoading] = useState(true);
  const [planTypeList, setPlanTypeList] = useState([]); //清冊類型
  const [companyPlaceList, setCompanyPlaceList] = useState([]);
  const [rows, setRows] = useState([]);
  const [planSn, setPlanSn] = useState(""); //分頁用key
  const [expandedRows, setExpandedRows] = useState({});

  const cols = [
    { field: "placeName", header: t("place") },
    { field: "displayCause", header: t("inventory_reason") },
    { field: "displayGwp", header: "GWP" },
  ];

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
    // if (e.keyCode === 13) {
    //     e.stopPropagation();
    // }
  };

  const findPlanYearIndex = (year) => {
    let result = planYearList?.filter((item) => item.subitemNo === year);
    return result.length > 0 ? result[0].index : false;
  };

  //組織邊界廠商清單
  const axios_getCompanyPlaceList = () => {
    // checkLoading(loading);
    setIsLoading(true);
    getCompanyPlaceList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.companyPlaceList;
          setCompanyPlaceList(data);
          if (getCompanyType() === "A") {
            setValue("companySeq", data[0].companySeq);
            trigger("companySeq");
          } else if (defaultCompanySeq !== "") {
            setValue("companySeq", defaultCompanySeq);
          }
        }
      })
      .finally(() => {
        // checkLoading(loading, false)
        setIsLoading(false);
      });
  };

  //碳盤查清單
  const axios_getCarbonPlanList = (reqBody, readMore = false) => {
    const body = {
      ...reqBody,
      planType: [
        Base64Encoder(BcryptEncoder("0")) + "," + findIndex("0", planTypeList),
        Base64Encoder(BcryptEncoder("1")) + "," + findIndex("1", planTypeList),
      ],
    };
    checkLoading(loading);
    getCarbonPlanList(body)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.planList;
          if (data?.length > 0) {
            setPlanSn(data[data?.length - 1].planSn);
            if (readMore === true) {
              setRows((pre) => {
                return [...pre, ...data];
              });
            } else {
              setSelPlan(null);
              setRows((pre) => {
                return [...data];
              });
            }
          } else {
            if (readMore === false) {
              setSelPlan(null);
              setRows([]);
            }
          }
        } else {
          if (readMore === false) {
            setSelPlan(null);
            setRows([]);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => checkLoading(loading, false));
  };

  const findIndex = (value, list) => {
    let result = list?.filter((item) => item.subitemNo === value);
    return result.length > 0 ? result[0].index : false;
  };

  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  const onSubmit = async (data) => {
    let reqBody = {
      companySeq: getValues("companySeq"),
    };
    if (data.startYear !== undefined) {
      reqBody.startYear = Base64Encoder(BcryptEncoder(data.startYear)) + "," + findPlanYearIndex(data.startYear);
      reqBody.endYear = Base64Encoder(BcryptEncoder(data.startYear)) + "," + findPlanYearIndex(data.startYear);
    }
    // console.log(reqBody);
    axios_getCarbonPlanList(reqBody);
  };

  //查詢更多
  const btnReadMore = () => {
    let reqBody = {
      companySeq: getValues("companySeq"),
      planSn: planSn,
    };
    if (getValues("placeSeq") !== "" && getValues("placeSeq") !== undefined) {
      reqBody.placeSeq = getValues("placeSeq");
    }
    if (getValues("startYear") !== undefined) {
      reqBody.startYear =
        Base64Encoder(BcryptEncoder(getValues("startYear"))) + "," + findPlanYearIndex(getValues("startYear"));
    }
    if (getValues("endYear") !== undefined) {
      reqBody.endYear =
        Base64Encoder(BcryptEncoder(getValues("endYear"))) + "," + findPlanYearIndex(getValues("endYear"));
    }
    // console.log(reqBody);
    axios_getCarbonPlanList(reqBody, true);
  };

  useEffect(() => {
    axios_getCompanyPlaceList();
    axios_getSubItemsByItemNo("INVENTORY_TYPE", 42).then(setPlanTypeList);
  }, []);

  // 切換某列展開
  const toggleRow = (rowId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  // 新增按鈕 Column body
  const collapseButtonBody = (rowData) => {
    const rowKey = rowData.placeSeq;
    const isExpanded = expandedRows[rowKey];
    const list = rowData.placeName || [];

    if (list.length <= 3) return null; // 少於兩個不用按鈕

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className="p-button-link p-0"
        style={{
          fontSize: "0.7rem",
          padding: "0.2rem",
          width: "1.2rem",
          height: "1.2rem",
        }}
        onClick={() => toggleRow(rowKey)}
      />
    );
  };

  // 調整 renderWithCollapse 右側文字不再包含按鈕
  const renderWithCollapse = (rowData, renderItem, textAlign = "left") => {
    const rowKey = rowData.placeSeq;
    const isExpanded = expandedRows[rowKey];
    const list = rowData.placeName || [];
    const showList = isExpanded ? list : list.slice(0, 3);

    return (
      <div>
        {showList.map((item, idx) => (
          <div
            key={idx}
            style={{
              textAlign: textAlign,
              lineHeight: "1.5rem",
              minHeight: "1.5rem",
            }}
          >
            {item}
          </div>
        ))}
      </div>
    );
  };

  const rawExpandBody = (rowData) => renderWithCollapse(rowData, (item) => item.placeName);

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown} className="grid">
            <div className="col-12 lg:col-6">
              <label htmlFor="placeName" className="form-label required">
                {t("organName")}
              </label>
              <Controller
                name="companySeq"
                control={control}
                rules={{ required: { value: true, message: t("validation.required") } }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    disabled={getCompanyType() === "A"}
                    appendTo={"self"}
                    optionLabel="companyName"
                    optionValue="companySeq"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="companySeq"
                    control={control}
                    options={companyPlaceList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "companySeq")}
            </div>

            <div className="col-12 lg:col-6">
              <label htmlFor="startYear" className="form-label required">
                {t("queryYear")}
              </label>

              <Controller
                name="startYear"
                rules={{ required: { value: true, message: t("validation.required") } }}
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    appendTo={"self"}
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="startYear"
                    control={control}
                    options={planYearList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "startYear")}
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button disabled={!isValid} type="submit" label={t("button.query")} />
            </div>
          </form>
        </div>
        <div className="p-card">
          <div className="p-card-body">
            <DataTable
              selectionMode="checkbox"
              selection={selPlan}
              onSelectionChange={(e) => {
                setSelPlan(e.value);
              }}
              stripedRows
              className="white-data-table hover-highlight no-shadow no-checkbox-all"
              value={rows}
              footer={
                rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
              }
              emptyMessage={<NoInfo panel="table" size="sm" />}
            >
              <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
              <Column header="" headerStyle={{ width: "3rem" }} body={collapseButtonBody}></Column>
              <Column
                field="placeName"
                header={t("place")}
                body={(rowData, rowIndex) => rawExpandBody(rowData, rowIndex)}
              />
              <Column field="displayCause" header={t("inventory_reason")} />
              <Column field="displayGwp" header="GWP" />
            </DataTable>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsolidateList;
